import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {
  TypeRemarqueState,
  FetchTypeRemarquesResponse,
  FetchTypeRemarqueByIdResponse,
  FetchAllTypeRemarquesResponse,
} from './types'
import {
  fetchTypeRemarqueById,
  fetchTypeRemarques,
  createTypeRemarque,
  updateTypeRemarque,
  deleteTypeRemarque,
  suspendTypeRemarque,
  activateTypeRemarque,
  fetchAllTypeRemarques,
} from './service'
import {ResponseError} from '../commonTypes'

const initialState: TypeRemarqueState = {
  typeRemarqueForEdit: null,
  typeRemarques: [],
  total: 0,
  totalPages: 0,
  listLoading: false,
  actionLoading: false,
  error: null,
}
const typeRemarqueSlice = createSlice({
  name: 'typeRemarque',
  initialState,
  reducers: {
    resetTypeRemarques: (state: TypeRemarqueState) => {
      state.typeRemarques = []
      state.total = 0
      state.totalPages = 0
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchTypeRemarques.pending, (state: TypeRemarqueState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchTypeRemarques.rejected,
      (state: TypeRemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchTypeRemarques.fulfilled,
      (state: TypeRemarqueState, action: PayloadAction<FetchTypeRemarquesResponse>) => {
        state.listLoading = false
        state.error = null
        const {typeRemarques, total, totalPages} = action.payload
        state.typeRemarques = typeRemarques
        state.total = total
        state.totalPages = totalPages
      }
    )

    builder.addCase(fetchAllTypeRemarques.pending, (state: TypeRemarqueState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchAllTypeRemarques.rejected,
      (state: TypeRemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload

        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchAllTypeRemarques.fulfilled,
      (state: TypeRemarqueState, action: PayloadAction<FetchAllTypeRemarquesResponse>) => {
        state.listLoading = false
        state.error = null
        const {typeRemarques} = action.payload
        state.typeRemarques = typeRemarques
      }
    )

    builder.addCase(fetchTypeRemarqueById.pending, (state: TypeRemarqueState) => {
      state.listLoading = true
      state.error = null
    })
    builder.addCase(
      fetchTypeRemarqueById.rejected,
      (state: TypeRemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.listLoading = false
      }
    )
    builder.addCase(
      fetchTypeRemarqueById.fulfilled,
      (state: TypeRemarqueState, action: PayloadAction<FetchTypeRemarqueByIdResponse>) => {
        state.typeRemarqueForEdit = action.payload.typeRemarque
        state.listLoading = false
        state.error = null
        state.typeRemarqueForEdit = action.payload.typeRemarque
      }
    )

    builder.addCase(createTypeRemarque.pending, (state: TypeRemarqueState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      createTypeRemarque.rejected,
      (state: TypeRemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      createTypeRemarque.fulfilled,
      (state: TypeRemarqueState, action: PayloadAction<FetchTypeRemarqueByIdResponse>) => {
        state.typeRemarqueForEdit = action.payload.typeRemarque
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(updateTypeRemarque.pending, (state: TypeRemarqueState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      updateTypeRemarque.rejected,
      (state: TypeRemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      updateTypeRemarque.fulfilled,
      (state: TypeRemarqueState, action: PayloadAction<FetchTypeRemarqueByIdResponse>) => {
        state.typeRemarqueForEdit = action.payload.typeRemarque
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(deleteTypeRemarque.pending, (state: TypeRemarqueState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      deleteTypeRemarque.rejected,
      (state: TypeRemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      deleteTypeRemarque.fulfilled,
      (state: TypeRemarqueState, action: PayloadAction<FetchTypeRemarqueByIdResponse>) => {
        state.typeRemarqueForEdit = action.payload.typeRemarque
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(suspendTypeRemarque.pending, (state: TypeRemarqueState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      suspendTypeRemarque.rejected,
      (state: TypeRemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      suspendTypeRemarque.fulfilled,
      (state: TypeRemarqueState, action: PayloadAction<FetchTypeRemarqueByIdResponse>) => {
        state.typeRemarqueForEdit = action.payload.typeRemarque
        state.actionLoading = false
        state.error = null
      }
    )

    builder.addCase(activateTypeRemarque.pending, (state: TypeRemarqueState) => {
      state.actionLoading = true
      state.error = null
    })
    builder.addCase(
      activateTypeRemarque.rejected,
      (state: TypeRemarqueState, action: PayloadAction<any>) => {
        const {error} = action.payload
        state.error = error
        state.actionLoading = false
      }
    )
    builder.addCase(
      activateTypeRemarque.fulfilled,
      (state: TypeRemarqueState, action: PayloadAction<FetchTypeRemarqueByIdResponse>) => {
        state.typeRemarqueForEdit = action.payload.typeRemarque
        state.actionLoading = false
        state.error = null
      }
    )
  },
})

export default typeRemarqueSlice.reducer
export const actions = typeRemarqueSlice.actions
